<div class="container">

  <div cesium #cesium [handleKeyboard]="mapHandleKeyboard"></div>
  @if (selectedSite  && referenceBatch && (selectedViewRepresentation == viewRepresentation.SPLITTED_TEXTURED || selectedViewRepresentation == viewRepresentation.SPLITTED_POINT_CLOUD) && (dateFormat$ | async); as dateFormat) {
    <div
      split-view-slider [scene]="scene"
      class="slider">
      <div class="info info-left">{{referenceBatch.dateAcquired | date:dateFormat}}</div>
      <div class="info info-right">{{selectedSite.lastBatchDate | date:dateFormat}}</div>
    </div>
  }

  <compute-loader></compute-loader>

  @if ((displayAdvancedActionBar$ | async)) {
    <world-actions-bar></world-actions-bar>
  }

  <viewer-display-panel></viewer-display-panel>

  @if ((itemSelected$ | async)) {
    <items-detail
    [ngClass]="{
     'items-detail-collapsed': !(itemDetailExpanded$ | async),
     'items-detail-extended': (itemDetailExpanded$ | async),
     }"></items-detail>
  }

</div>
